import { Grid } from "@mui/material";
import { FormSection } from "components/FormControls/FormSection";
import { OLCheckbox } from "components/FormControls/OLCheckbox";
import { useMessage } from "hooks/intl";

interface Props {
  fieldNamePrefix: "customer" | "referrer";
}

export const Agreements = ({ fieldNamePrefix }: Props) => {
  const { message } = useMessage();

  return (
    <FormSection title={message({ id: "agreements" })}>
      <Grid container spacing={12}>
        <Grid item xs={12}>
          <OLCheckbox
            label={message({ id: "basicLegalAgreement" })}
            sublabel={message({ id: "agreeToParticipateInLoyaltyProgram" })}
            name={`${fieldNamePrefix}.legalConsent`}
            data-test-id="basic-legal-agreements"
          />
        </Grid>
        <Grid item xs={12}>
          <OLCheckbox
            label={message({ id: "marketingAgreement" })}
            sublabel={message({ id: "agreeToReceiveMarketingCommunications" })}
            name={`${fieldNamePrefix}.marketingConsent`}
            data-test-id="marketing-agreement"
          />
        </Grid>
        <Grid item xs={12}>
          <OLCheckbox
            label={message({
              id: "dataProcessingAgreement",
            })}
            sublabel={message({
              id: "agreeToProcessingDataCollectedFromLoyaltySystems",
            })}
            name={`${fieldNamePrefix}.dataProcessingConsent`}
            data-test-id="data-processing-agreement"
          />
        </Grid>
      </Grid>
    </FormSection>
  );
};
